import React from 'react';
import { AdminPanel } from './AdminPanel';

const ADMIN_KEY = 'sekret123';

const AdminPage: React.FC = () => {
  // First, try to get from URL
  const params = new URLSearchParams(window.location.search);
  let adminKey = params.get('admin_key');
  let adminToken = params.get('admin_token');

  // If present in URL — save to sessionStorage
  if (adminKey) {
    sessionStorage.setItem('admin_key', adminKey);
  } else {
    // If not in URL — try to get from sessionStorage
    adminKey = sessionStorage.getItem('admin_key');
  }

  if (adminToken) {
    sessionStorage.setItem('admin_token', adminToken);
  } else {
    adminToken = sessionStorage.getItem('admin_token');
  }

  const isAllowed = adminKey === ADMIN_KEY;

  console.log('AdminPage rendered');
  console.log('adminKey from URL or sessionStorage:', adminKey);

  if (!isAllowed) return <div>Access denied</div>;

  return <AdminPanel adminToken={adminToken || ''} />;
};

export default AdminPage; 
